import { CalendarEventGuest } from '@griply/types';

import { isValidEmail } from './is-valid-email';

export const addCalendarEventGuest = (
  guests: CalendarEventGuest[],
  rawEmail: string,
  name?: string | null,
): CalendarEventGuest[] => {
  const email = rawEmail.trim().toLowerCase();
  if (!isValidEmail(email)) {
    return guests;
  }
  if (guests.some((guest) => guest.email.toLowerCase() === email)) {
    return guests;
  }

  return [...guests, name ? { email, name } : { email }];
};

export const removeCalendarEventGuest = (
  guests: CalendarEventGuest[],
  email: string,
): CalendarEventGuest[] => guests.filter((guest) => guest.email !== email);
